import React from 'react';

const MobileLineBreak: React.FC = () => <br className="mobile-only" />;

export default MobileLineBreak;
